import {mockAcademicYear, mockRegion} from '../generate-mock-data';
import {School} from '../../../types/__generated__/data-contracts';


export const MOCK_SCHOOL_DATA: School = {
    academicYear: mockAcademicYear(undefined, 1),
    schoolId: 1,
    crmId: 123,
    name: 'anup dagade',
    region: mockRegion(undefined, 12),
    schoolAdmin: 'testSchool',
    country: 'Australia',
    city: 'sydney',
    hasFutureSchoolAcademicYear: true
};

export const DEFAULT_STATE = {
    isOpen: false,
    isLoading: false,
    endDate: null,
    school: null
}
